import { put, call } from "redux-saga/effects";
import { getUserLocation } from "../../services/userLocation";
import { DefaultLocation } from "../../constants/location";
import { set } from "../actions/location";

function* saveLocation() {
  try {
    const response = yield call(getUserLocation);
    const { latitude, longitude } = response.currentLocation.coords;
    yield put(set(latitude, longitude));
  } catch (e) {
    yield put(set(DefaultLocation.lat, DefaultLocation.lng));
  }
}


export default [
  saveLocation,
];
